export const getFavoritesRequestParams = (element, operationType, id) => {
  const operation = operationType === 'remove'
    ? `remove_${element}_from_favorites`
    : `add_${element}_to_favorites`;

  return {
    method: 'POST',
    body: JSON.stringify({
      operation,
      id,
    }),
  }
};



// WEBPACK FOOTER //
// ./src/common/favoritesServiceHelper.js